import Store from 'store';
import { Color } from 'common';

class DataClass {
  options = {};

  _animIndex = new Map();

  classes = ['ama', 'sor', 'nec', 'pal', 'bar', 'dru', 'ass'];
  strClassSkillsStat = [3525, 3528, 3527, 3526, 3529, 21205, 11158];
  strClassOnly = [10917, 10918, 10919, 10920, 10921, 10922, 10923];
  strSkilltabStat = [
    10056, 10055, 10054, // bow / pas / jav
    10068, 10067, 10066, // fir / lit / col
    10062, 10061, 11003, // cur / psn / sum
    10059, 10058, 10057, // com / off / def
    10064, 10065, 10063, // com / mas / war
    10069, 10070, 10071, // sum / sha / ele
    10072, 10073, 10074  // tra / sha / mar
  ];

  classNames = {
    ama: 'Amazon',
    sor: 'Sorceress',
    nec: 'Necromancer',
    pal: 'Paladin',
    bar: 'Barbarian',
    dru: 'Druid',
    ass: 'Assassin',
  };
  
  classSkillIcons = {
    '': 'Skillicon',
    ama: 'AmSkillicon',
    sor: 'SoSkillicon',
    nec: 'NeSkillicon',
    pal: 'PaSkillicon',
    bar: 'BaSkillicon',
    dru: 'DrSkillicon',
    ass: 'AsSkillicon',
  };
  
  qualityColor = [
    Color.WHITE,
    Color.WHITE,
    Color.WHITE,
    Color.BLUE,
    Color.YELLOW,
    Color.GREEN,
    Color.GOLD,
    Color.GOLD,
    Color.ORANGE,
  ];
    
  animData(name) {
    const offset = this._animIndex.get(name);
    if (!offset) return null;
    return this._animData.subarray(offset, offset + 4);
  }

  addOption(name, value, perProfile=false) {
    this.options[name] = {
      initial: value,
      profile: perProfile,
      select: this.getOption.bind(this, name),
    };
  }
  getOption(name, state) {
    if (!state) state = Store.instance.getState();
    const option = this.options[name];
    if (!option) return null;
    if (option.profile) {
      state = state.profiles[state.activeProfile];
    }
    return state.active[name] === undefined ? option.initial : state.active[name];
  }
  setOption(name, value, dispatch) {
    if (!dispatch) dispatch = Store.dispatch;
    const option = this.options[name];
    if (!option) return;
    if (option.profile) {
      dispatch = dispatch.profile;
    }
    dispatch.setActive(name, value);
  }

  useOption(name) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return Store.useSelector(this.options[name].select);
  }
}

const Data = new DataClass();

export default Data;
